var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
export function Icon(_a) {
    var { className, name, width = '1em', height = '1em', xLinkHref = '/images/bootstrap-icons.svg' } = _a, props = __rest(_a, ["className", "name", "width", "height", "xLinkHref"]);
    return (React.createElement("svg", Object.assign({ className: classNames('bi', className), width: width, height: height }, props),
        React.createElement("use", { className: "text-warning", xlinkHref: `${xLinkHref}#${name}` })));
}
export default Icon;
//# sourceMappingURL=index.js.map